import { useLoaderData, useParams } from 'react-router';
import { Type } from '@mindstep-axa-dmhi/dmhi-frontend-components';
import {
  BackButton,
  Button,
  ButtonGroup,
  Hero,
  Link,
} from '../../../../components';
import { LayoutLanding } from '../../../../layouts';
import useTranslate from '../../../../hooks/use-translate';
import useCanonical from '../../../../hooks/use-canonical';

function ScreeningIntro() {
  const { Screening } = useLoaderData();
  const { assessmentId } = useParams();
  const { canonical } = useCanonical();
  const { trans, t } = useTranslate([
    Screening.intro.title,
    Screening.intro.content,
  ]);

  return (
    <LayoutLanding hero={<Hero img={Screening.intro.background} />}>
      <link rel="canonical" href={canonical} />
      <BackButton variant="button" className="absolute top-0 left-0 ml-6 mt-4" />
      <div className="flex flex-col gap-8 mx-auto md:gap-16 lg:gap-12 lg:max-w-[500px]">
        <Type variant="h1" className="text-center">
          {trans[Screening.intro.title]}
        </Type>
        <Type variant="lead">{trans[Screening.intro.content]}</Type>
        <ButtonGroup>
          <Button
            component={Link}
            to="consent"
            variant="primary"
            id="start"
            state={{ next: `/assessment/${assessmentId}/start` }}
          >
            {t(Screening.intro.cta)}
          </Button>
        </ButtonGroup>
      </div>
    </LayoutLanding>
  );
}

export default ScreeningIntro;
